var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serviceAgreement"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"block",on:{"click":function($event){return _vm.goDetail(item.url)}}},[_vm._v(" "+_vm._s(item.title)),_c('span',{staticClass:"torightTag"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }